import React from 'react';

import YouTubeEmbed from '../YouTubeEmbed/YouTubeEmbed';
import BlockWrapper from './BlockWrapper';

const VideoBlock = ({ block }) => (
  <BlockWrapper>
    <YouTubeEmbed videoData={block} />
  </BlockWrapper>
);

export default VideoBlock;
